import React, { Component } from 'react';

export default class MainRowSection extends Component {

  render() {
    return (
      <div className='pageHead-mainRow wrapper'>
        <h1 className='pageHead-title'>Inventario</h1>
        <div className='pageHead-mainRow-actions'>
          <button className='btn btn-primary' data-toggle='modal' data-target='#inventarioCreacion'>Nuevo inventario</button>
          <div className='dropdown kebab' role='group'>
            <button className='btn dropdown-toggle kebab-btn' data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'><i className='ion-android-more-vertical' /></button>
            <ul className='dropdown-menu dropdown-menu-right'>
              <li><a className='pageHead-tableActionItem'><i className='ion-android-mail c-cyan' /><span>Compartir por Email</span></a></li>
              <li><a className='pageHead-tableActionItem'><i className='ion-arrow-down-a c-cyan' /><span>Descargar PDF</span></a></li>
              <li><a className='pageHead-tableActionItem'><i className='ion-arrow-down-a c-cyan' /><span>Descargar Excel</span></a></li>
              <li><a className='pageHead-tableActionItem'><i className='ion-android-print c-cyan' /><span>Imprimir</span></a></li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FichaLogistica/Inventario/MainRowSection.js